import classNames from './MoveStudentsPopup.module.scss';
import { TFunction } from 'i18next';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import { MoveClassDestination } from '@/school-management/types/services/bulk';

export interface StudentsTableData {
  name: string;
  currentClassAndGrade: string;
  destinationClassAndGrade: string;
}

export const convertStudentReportItemToStudentsTableData = (
  student: StudentReportItem,
  classDestination: MoveClassDestination,
  t: TFunction
) => {
  return {
    name: student.name,
    currentClassAndGrade: `${student.groupName} | ${t(`grade_${student.gradeId}`)} ${t('grade')}`,
    destinationClassAndGrade: `${classDestination.groupName} | ${t(`grade_${classDestination.gradeId}`)} ${t('grade')}`,
  } as StudentsTableData;
};

interface StudentsTableProps {
  students: StudentsTableData[];
}

const StudentsTable = ({ students }: StudentsTableProps) => {
  const { t } = useAdminTranslation();

  return (
    <div className={classNames.table}>
      <div className={classNames.tableHeader}>
        <div>{t('bulkActions.common.name')}</div>
        <div>{t('bulkActions.moveStudents.studentsTable.currentClassAndGrade')}</div>
        <div>{t('bulkActions.moveStudents.studentsTable.destinationClassAndGrade')}</div>
      </div>
      <div className={classNames.tableBody}>
        {(students || []).map((s, i) => (
          <div key={`StudentsTable-row--${i}`} className={classNames.tableRow}>
            <div>{s.name}</div>
            <div>{s.currentClassAndGrade}</div>
            <div>{s.destinationClassAndGrade}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentsTable;
